<template>

    <div class="modal fade" id="modalAllTask" tabindex="-1" aria-labelledby="exampleModalLabel">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Task associate all'item</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <button class="btn btn-primary btn-sm float-end" @click="creaTask()">
                        <i class="icon-pencil"></i> Crea Task
                    </button>
                    <div v-if="arrayTaskByModulo.length > 0">
                        <table class="table table-sm" style="overflow: auto;">
                            <thead>
                                <tr>
                                    <th style="width:2%"></th>
                                    <th style="width:30%">Titolo</th>
                                    <th style="width:30%">Descrizione</th>
                                    <th style="width:20%">Scadenza</th>
                                    <th style="width:20%;">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="task in arrayTaskByModulo" :key="task.ID_TASK">
                                    <td><input type="checkbox" :checked="task.COMPLETATA == 1" @change="toggleCompletamentoItem(task, $event)"></td>
                                    <td style="width:30%">
                                        {{ task.TITOLO }}
                                        <i v-if="task.PROMEMORIA == 1" class="fa fa-bell text-warning ms-1"></i>
                                    </td>
                                    <td style="width:30%">{{ task.DESCRIZIONE }}</td>
                                    <td style="width:20%">{{ filters.formatDate(task.DATA_SCADENZA) }}</td>
                                    <td style="width:20%">
                                        <div v-if="task.COMPLETATA == 0">
                                            <button class="btn btn-warning btn-sm" @click="modificaTask(task)">
                                                <i class="fa fa-pencil"></i>
                                            </button>
                                            <button class="btn btn-danger btn-sm" @click="eliminaTask(task)">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                            <button class="btn btn-primary btn-sm" @click="gestisciPromemoria(task)">
                                                <i class="fa fa-bell"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="text-muted text-center py-3">
                        Non ci sono task associate a questo item.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ModalToDo ref="modalTodo" :task="taskSelezionata" :categories="arrayCategories" :arrayUtenti="arrayUtenti"
        @salva="salvaTask" @task-multipla-creata="$emit('taskMultiplaCreata')"></ModalToDo>
    <PromemoriaForm ref="promemoriaForm" :task="taskSelezionata" :utente="$root.utente" 
        @salvato="getTaskByModulo()" @eliminato="getTaskByModulo()"></PromemoriaForm>

</template>


<script>

import ModalToDo from './ModalToDo.vue';
import PromemoriaForm from './PromemoriaForm.vue';

export default {
    name: 'ModalAllTask',

    components: {
        ModalToDo, PromemoriaForm
    },

    emits:['taskMultiplaCreata'],

    props: {
        modulo: {
            type: Number,
            required: true,
        },
    },
    
    data() {
        return {
            filters: global.filters,
            arrayCategories: [],
            arrayTaskByModulo: [],
            taskSelezionata: {},
            idUtente: this.$root.utente.ID_UTENTE,
            idItem: 0,
            arrayUtenti: this.$root.arrayUtentiAdmin,
        };
    },
    methods: {
        gestisciPromemoria(task) {
            this.taskSelezionata = utils.clone(task);
            this.$refs.promemoriaForm.openPromemoria(task);
        },
        apriModale(idItem) {
            this.idItem = idItem;
            this.getTaskByModulo();
            this.filters.openPopUp('modalAllTask');
        },
        getTaskByModulo() {
            utils.ajax('todo/tasks/get/by/modulo', { ID_UTENTE: this.idUtente, FK_ID_MODULO: this.modulo, FK_ID_ITEM: this.idItem }, (response) => {
                if (response.esito == 0) {
                    this.arrayTaskByModulo = response.data;
                } else {
                    console.log('Errore durante il caricamento delle task in base al modulo: ' + response.messaggio);
                }
            });
        },
        loadCategorie(idUtente) {
            utils.ajax('todo/categorie/get', { ID_UTENTE: idUtente }, (response) => {
                if (response.esito == 0) {
                    this.arrayCategories = response.data;
                }
            });
        },
        creaTask(arraySelezionati = [], modulo) {
            if(arraySelezionati.length > 0){
                this.taskSelezionata = { ID_TASK: 0, CONDIVISO: 0 , FK_ID_MODULO : modulo};
                this.$refs.modalTodo.createMoreTask(arraySelezionati,modulo);
            } else {
                this.taskSelezionata = {};
                this.$refs.modalTodo.createTask();
            }
        },
        modificaTask(task) {
            this.taskSelezionata = task;
            this.$refs.modalTodo.editTask();
        },
        eliminaTask(task) {
            if (confirm('Sei sicuro di voler eliminare questa task?')) {
                utils.ajax('todo/task/delete/by/modulo', { FK_ID_TASK: task.ID_TASK, FK_ID_MODULO: task.FK_ID_MODULO, FK_ID_ITEM: task.FK_ID_ITEM  }, (response) => {
                    if (response.esito == 0) {
                        this.getTaskByModulo();
                        utils.alert.success("Task eliminata con successo");
                    } else {
                        utils.alert.danger("Errore durante l'eliminazione della task: " + response.messaggio);
                    }
                });
            }
        },
        salvaTask(task) {
            if (task.ID_TASK > 0) {
                utils.ajax('todo/task/update', task, (response) => {
                    if (response.esito == 0) {
                        this.getTaskByModulo();
                        utils.alert.success("Task aggiornata con successo");
                    } else {
                        utils.alert.danger("Errore durante l'aggiornamento della task: " + response.messaggio);
                    }
                });
            } else {
                // Create new task
                task.FK_ID_MODULO = this.modulo;
                task.FK_ID_ITEM = this.idItem;
                utils.ajax('todo/task/insert', task, (response) => {
                    if (response.esito == 0) {
                        this.getTaskByModulo();
                        utils.alert.success("Task creata con successo");
                    } else {
                        utils.alert.danger("Errore durante la creazione della task: " + response.messaggio);
                    }
                });
            }
        },
        toggleCompletamentoItem(task, event) {
            const nuovoStato = event.target.checked ? 1 : 0;
            const payload = {
                FK_ID_TASK: task.ID_TASK,
                FK_ID_MODULO: task.FK_ID_MODULO,
                FK_ID_ITEM: this.idItem,
                COMPLETATA: nuovoStato
            };
            console.log("Payload inviato:", payload);
            utils.ajax('todo/task/item/completa', payload, (response) => {
                if (response.esito == 0) {
                    this.getTaskByModulo();
                    utils.alert.success("Task aggiornata correttamente per l'item");
                } else {
                    utils.alert.error("Errore nel completamento della task: " + response.messaggio);
                }
            });
        }

    },
    created() {
        this.loadCategorie(this.idUtente);

    }
}   
</script>

<style scoped></style>